import { api_dominios } from 'services/apis'

interface sendSignContractTokenMailProps {
  id_concc030: number
}

export const sendSignContractTokenMail = async ({
  id_concc030
}: sendSignContractTokenMailProps) => {
  const urlMail = `${window.location.origin}/permissao-token-contrato`
  const endpoint = `/proposta/jornada/${id_concc030}/assinatura-digital-codigo-email`

  const response = await api_dominios.post(endpoint, {}, { params: { url: urlMail } })

  return response.data
}

interface sendTokenSignContractProps {
  codigo: string
  id_concc030_cript: number | string
}

export const postContractToken = async ({
  codigo,
  id_concc030_cript
}: sendTokenSignContractProps) => {
  const token = codigo
  const URL = `/proposta/jornada/${token}/assinatura-digital-verifica-codigo-contrato`
  const response = await api_dominios.post(URL, id_concc030_cript, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
  return response.data.data
}

interface postDownloadContractConfirmationProps {
  id_concc030_cript: number | string
}

export const postAssignContractConfirmation = async ({
  id_concc030_cript
}: postDownloadContractConfirmationProps) => {
  const URL = `/proposta/jornada/assinatura-digital-assinar`
  const response = await api_dominios.post(URL, id_concc030_cript, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
  return response.data
}
